import { knowledgeBaseSectionsQuery } from "@/views/settings/base-knowledge/index/gql/queries";
import { fetchKnowledgeBaseItems as fetchKnowledgeBaseItemsRequest } from "@/views/settings/base-knowledge/services/items";

export default {
  namespaced: true,
  state: {
    categories: [],
    knowledgeBaseSections: [],
    knowledgeBaseItems: [],
    filtersForm: {
      nameContains: "",
      sectionId: "",
      audience: "",
    },
  },

  getters: {
    getQueryVariables(state) {
      return () => {
        const { nameContains, sectionId, audience } = state.filtersForm;
        const variables = {};

        if (nameContains) variables.nameContains = nameContains;
        if (sectionId) variables.sectionId = sectionId;
        if (audience) variables.audience = audience;

        return variables;
      };
    },
    getKnowledgeBaseSections(state) {
      return state.knowledgeBaseSections.filter((section) => !section.parentId);
    },
    getKnowledgeBaseItems(state) {
      return state.knowledgeBaseItems.filter((item) => !item.parentId);
    },
  },

  mutations: {
    SET_CATEGORIES(state, category) {
      state.categories = category;
    },

    SET_CATEGORY(state, form) {
      state.filtersForm.sectionId = form;
    },

    SET_SEARCH(state, search) {
      state.filtersForm.nameContains = search;
    },

    SET_AUDIENCE(state, audience) {
      state.filtersForm.audience = audience;
    },

    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },

    SET_KNOWLEDGE_BASE_SECTIONS(state, knowledgeBaseSections) {
      state.knowledgeBaseSections = knowledgeBaseSections;
    },

    SET_KNOWLEDGE_BASE_ITEMS(state, knowledgeBaseItems) {
      state.knowledgeBaseItems = knowledgeBaseItems;
    },
  },
  actions: {
    async fetchKnowledgeBaseItems({ commit }, parentId = null) {
      try {
        commit("loaderTop/SET_LOADING_ON", undefined, { root: true });

        const knowledgeBaseItems = await fetchKnowledgeBaseItemsRequest(parentId);

        commit("SET_KNOWLEDGE_BASE_ITEMS", knowledgeBaseItems);

        return knowledgeBaseItems;
      } finally {
        commit("loaderTop/SET_LOADING_OFF", undefined, { root: true });
      }
    },

    async fetchKnowledgeBaseSections({ commit }, parentId = null) {
      try {
        commit("loaderTop/SET_LOADING_ON", undefined, { root: true });

        const { default: apolloClient } = await import("@/plugins/apollo-vue");
        const response = await apolloClient.query({
          query: knowledgeBaseSectionsQuery,
          fetchPolicy: "network-only",
          ...(parentId ? { variables: { parentId: parentId } } : {}),
        });
        const knowledgeBaseSections = response?.data?.knowledgeBaseSections;

        if (!knowledgeBaseSections) {
          return;
        }

        commit(
          "SET_KNOWLEDGE_BASE_SECTIONS",
          knowledgeBaseSections.map(({ id, name, parentId }) => ({
            id,
            name,
            parentId,
          }))
        );

        return knowledgeBaseSections;
      } finally {
        commit("loaderTop/SET_LOADING_OFF", undefined, { root: true });
      }
    },
  },
};
